import React, { useEffect } from 'react';
import { UseFormMethods } from 'react-hook-form';
import Button from 'src/components/controls/forms/redesign/FormButton';
import Abstract from 'src/models/Abstract';
import { SelectItem } from 'src/models/common/SelectItem';
import { DialogContext, dialogCreators } from 'src/providers/DialogProvider';

interface IRHFEastTexasSurveyPanelProps extends Partial<Pick<UseFormMethods, 'setValue' | 'getValues'>> {
    counties: SelectItem[];
    abstracts: Abstract[];
    addAbstract: (abstract: Abstract) => void;
    deleteAbstract: (index: number) => void;
}

// TODO: Investigate this and determine if form field values are necessary.
const RHFEastTexasSurveyPanel = (props: IRHFEastTexasSurveyPanelProps) => {
    const dialogContext = React.useContext<dialogCreators>(DialogContext);
    const [abstracts, setAbstracts] = React.useState<Array<Abstract>>([]);
    const [loading, setLoading] = React.useState<boolean>(true);

    useEffect(() => {
        if (props?.abstracts?.length > 0) {
            setAbstracts(props.abstracts);
        }
        if (!!props?.abstracts) {
            setLoading(false);
        }
    }, [props]);

    const onAbstractSelected = (selectedAbstract: Abstract) => {
        if (abstracts.filter((a) => a.id === selectedAbstract.id).length === 0) {
            props.setValue(`eastTexasAbstractIds[${abstracts.length}]`, selectedAbstract.id);
            props.setValue('dirtyEastTexasAbstracts', Math.random().toString(36).substring(2, 7));
            setAbstracts((a) => [...a, selectedAbstract]);
            props.addAbstract(selectedAbstract);
        }
    };

    const openDialog = () => {
        dialogContext.tract.addEastTexasAbstract(props.counties, onAbstractSelected);
    };

    const clearAbstract = (index: number) => {
        const propAbstractIds = (props.getValues()?.values as { eastTexasAbstractIds: number[] })?.eastTexasAbstractIds;
        const ids = propAbstractIds?.filter((id, i) => i !== index);
        setAbstracts(abstracts?.filter((_, i) => i !== index));
        props.setValue('eastTexasAbstractIds', ids);
        props.setValue('dirtyEastTexasAbstracts', Math.random().toString(36).substring(2, 7));
        props.deleteAbstract(index);
    };

    const abstractPanel = () => {
        if (loading) {
            return <div>loading...</div>;
        }

        if (abstracts.length === 0) {
            return (
                <div style={{ fontWeight: 'bold', padding: '1rem' }}>
                    No Abstract Selected -{' '}
                    <span onClick={openDialog} style={{ color: '#6393C1', cursor: 'pointer' }}>
                        Select Abstract
                    </span>
                </div>
            );
        }

        const mainStyle: React.CSSProperties = {
            backgroundColor: 'transparent',
            position: 'relative',
            padding: '1rem',
        };

        const altStyle: React.CSSProperties = {
            backgroundColor: '#f5f5f5',
            position: 'relative',
            padding: '1rem',
        };

        return (
            <>
                {abstracts?.map((a, index) => (
                    <div key={index} style={index % 2 === 0 ? mainStyle : altStyle}>
                        <div>
                            <span style={{ fontWeight: 'bold' }}>Number:</span> {a.abstractNumber}
                            <span style={{ fontWeight: 'bold' }}>&nbsp;&nbsp;&nbsp;Name:</span> {a.name}
                            <span style={{ fontWeight: 'bold' }}>&nbsp;&nbsp;&nbsp;Acres:</span> {a.acres}
                        </div>
                        <div>
                            <span style={{ fontWeight: 'bold' }}>Legal:</span> {a.legal || '[No Legal]'}
                            <span style={{ fontWeight: 'bold' }}>&nbsp;&nbsp;&nbsp;Section:</span> {a.section || '[No Section]'}
                        </div>
                        <div style={{ position: 'absolute', top: '1rem', right: '1rem' }}>
                            <Button intent="primary" text="Remove Abstract" onClick={() => clearAbstract(index)} />
                        </div>
                    </div>
                ))}
            </>
        );
    };

    return (
        <>
            <fieldset style={{ padding: '.3rem 0', borderWidth: '1px 0 0 0', marginBottom: '.2rem' }}>
                <legend className="legend">Texas Abstract</legend>
            </fieldset>
            {abstracts && abstracts.length > 0 && (
                <div style={{ border: '1px solid #ccc', background: 'white', padding: '1rem', marginBottom: '1rem' }}>
                    <div style={{ fontWeight: 'bold' }}>
                        <span onClick={openDialog} style={{ color: '#6393C1', cursor: 'pointer' }}>
                            Add Another Abstract
                        </span>
                    </div>
                </div>
            )}
            <div style={{ border: '1px solid #ccc', background: 'white', padding: 0, marginBottom: '1rem' }}>{abstractPanel()}</div>
        </>
    );
};

export default RHFEastTexasSurveyPanel;


// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/panels/EastTexasSurvePanel.redesign.tsx